/**
 * Generates the TXT content to export subtitles.
 * Format: name (name)\n\nspeakerLanguage (speaker-language): text (text)
 * If it has bilingualText: two lines (sourceLanguage + bilingualText, speakerLanguage + text)
 */
export function buildSubtitlesTxtContent(subtitles) {
    if (!subtitles || subtitles.length === 0) return '';

    const lines = [];
    let lastName = '';

    subtitles.forEach((item) => {
        if (item.name !== lastName) {
            lines.push('');
            lines.push(`${item.name}`);
            lastName = item.name;
        }

        if (item.bilingualText) {
            // Line 1: source language with bilingualText
            lines.push(
                `${item.sourceLanguage || item.speakerLanguage}[${item.time}]: ${item.bilingualText}`,
            );
            // Line 2: destination language with text
            lines.push(`${item.speakerLanguage}[${item.time}]: ${item.text}`);
        } else {
            lines.push(`${item.speakerLanguage}[${item.time}]: ${item.text}`);
        }
    });

    return lines.join('\n');
}

function buildSubtitlesFile(subtitles) {
    let content = [];
    subtitles.forEach((item, index) => {
        if (index === 0 || item.name !== subtitles[index - 1].name) {
            content.push({
                text: item.name,
                style: 'header',
                bold: true,
            });
        } else {
            content.push({
                text: '',
                style: 'header',
                bold: true,
            });
        }

        if (item.bilingualText) {
            content.push({
                ul: [
                    {
                        text: `(${item.speakerLanguage}): ${item.bilingualText}`,
                        italics: true,
                        color: '#555',
                    },
                    {
                        text: `(${item.speakerLanguage}): ${item.text}`,
                        bold: false,
                    },
                ],
            });
        } else {
            content.push({
                ul: [
                    {
                        text: `(${item.speakerLanguage}): ${item.text}`,
                        bold: false,
                    },
                ],
            });
        }
    });
    return content;
}

export default buildSubtitlesFile;
